export interface AiChatbotChatRequest {
    threadId?: string | null;
    chatMessage: string;
    orderId?: number | null;
}

export type ChatMessageRole = 'user' | 'assistant' | 'system';

export type ChatbotVisualState = 'initial' | 'processing' | 'success';

export interface ChatMessage {
    role: ChatMessageRole;
    text: string;
}

export const AI_CHATBOT_MESSAGE_KEYS = {
    initialGreeting: 'AI_CHATBOT.MESSAGE.INITIAL_GREETING',
    orderContextConsentPrompt: 'AI_CHATBOT.MESSAGE.ORDER_CONTEXT_CONSENT_PROMPT',
    orderContextAccepted: 'AI_CHATBOT.MESSAGE.ORDER_CONTEXT_ACCEPTED',
    orderContextRejected: 'AI_CHATBOT.MESSAGE.ORDER_CONTEXT_REJECTED',
    noResponse: 'AI_CHATBOT.MESSAGE.NO_RESPONSE',
    streamStopped: 'AI_CHATBOT.MESSAGE.STREAM_STOPPED',
} as const;

export const AI_CHATBOT_ERROR_KEYS = {
    requestFailed: 'AI_CHATBOT.ERROR.REQUEST_FAILED',
    timeout: 'AI_CHATBOT.ERROR.TIMEOUT',
} as const;

export const INITIAL_CHATBOT_MESSAGES: ChatMessage[] = [];

export interface RawAiChatbotChatResponse {
    threadId?: string;
    ThreadId?: string;
    responseText?: string;
    ResponseText?: string;
}

export interface AiChatbotChatResponse {
    threadId: string;
    responseText: string;
}

export type AiChatbotStreamEventType = 'thread_started' | 'delta' | 'completed';

export interface AiChatbotStreamEvent {
    type: AiChatbotStreamEventType;
    threadId?: string;
    deltaText?: string;
    responseText?: string;
}

export interface AiChatbotStreamError {
    message: string;
    partialResponseText?: string;
}
